/**
 * Environment Slider
 * @requires https://swiperjs.com/
 */

export default (() => {
  /* eslint-disable no-undef, no-unused-vars  */
  const bgImageSlider = new Swiper('#environment-slider', {
    effect: 'fade',
    allowTouchMove: false,
    loop: true,
    speed: 500,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
  })

  /* eslint-enable no-undef, no-unused-vars  */
})()
